
<gt-dialog-header [message]="'yellow_pages.header' | translate" icon="search" (closing)="onClose()" [hidden]="selectedEntry"></gt-dialog-header>
<div fxLayout="column" [hidden]="selectedEntry">
  <mat-form-field floatPlaceholder="never" fxLayout="row">
    <input matInput
           [(ngModel)]="query"
           name="query"
           (keyup.enter)="onClick()"
           placeholder="{{'yellow_pages.placeholder' | translate}}">
    <button class="icon-button" [hidden]="loading" matSuffix mat-icon-button (click)="onClick()">
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>

  <div id="loadingSpinnerDiv" fxLayout="row" fxLayoutAlign="center center" *ngIf="loading">
    <mat-progress-spinner class="loadingSpinner" color="primary" mode="indeterminate"></mat-progress-spinner>
  </div>

  <div mat-dialog-content [hidden]="dataSource.contactList.length === 0">
    <mat-table #table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'yellow_pages.col_name' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.name}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="number">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'yellow_pages.col_number' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.phoneNumber | phoneNumberFormatter}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button mat-icon-button color="primary" (click)="click2call(row)" [disabled]="!row.phoneNumber" gtDisableWhenNotloggedin>
            <mat-icon>phone</mat-icon>
          </button>
          <button mat-icon-button color="primary" (click)="navigateToMsg(row)" [disabled]="!row.phoneNumber">
            <mat-icon>message</mat-icon>
          </button>
          <button mat-icon-button color="primary" (click)="handleRowClick(row)">
            <mat-icon>person_add</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"
               style="cursor: pointer;"></mat-row>

    </mat-table>
  </div>
</div>

<gt-contact-detail *ngIf="selectedEntry" [contact]="selectedEntry" (back)="backToTable()" [showCancelButton]="false"></gt-contact-detail>
